
const initialState = {
  data: {
    resultContainer: [],
    loading: false,
    page: 0,
    pageSize: 10,
    totalCount: 0
  },
  error: null,
  selectedRows: [],
  payload: {
  sortingCriteria: "DATE_NEWEST_TO_OLDEST",
  }
};

export const queryPageRequest = (namespace) => (state = initialState, action) => {
  switch (action.type) {
    case `${namespace}/QUERY_PAGE_REQUEST_REQUEST`: {
      return { ...state, data: { ...initialState.data, loading: true }, error: null };
    }
    case `${namespace}/QUERY_PAGE_REQUEST_SUCCESS`: {
      return { ...state, data: { ...state.data, resultContainer: action?.data?.resultContainer, page: action?.data?.pageIndex, pageSize: state.data.pageSize, totalCount: action?.data?.totalRowCount, loading: false } };
    }
    case `${namespace}/QUERY_PAGE_REQUEST_FAILURE`: {
      return { ...state, data: { ...state.data, resultContainer: [], page: 0, pageSize: state.data.pageSize, totalCount: 0, loading: false }, error: action?.error };
    }
    case `${namespace}/QUERY_PAGE_REQUEST_SET_PAGE`: {
      return { ...state, data: { ...state.data, page: action?.data?.page } }
    }
    case `${namespace}/QUERY_PAGE_REQUEST_RESET_PAGE`: {
      return { ...state, data: { ...state.data, page: 0 } }
    }
    case `${namespace}/QUERY_PAGE_REQUEST_SET_PAGE_SIZE`: {
      return { ...state, data: { ...state.data, page: 0, pageSize: action?.data?.pageSize } }
    }
    case `${namespace}/QUERY_PAGE_REQUEST_RESET_PAGE_SIZE`: {
      return { ...state, data: { ...state.data, pageSize: action?.data?.pageSize } }
    }
    case `${namespace}/QUERY_PAGE_REQUEST_SET_PAGE_AND_PAGE_SIZE`: {
      return { ...state, data: { ...state.data, page: action?.data?.page, pageSize: action?.data?.pageSize } }
    }
    case `${namespace}/QUERY_PAGE_REQUEST_SET_PAYLOAD`: {
      return { ...state, data: { ...state.data, page: 0, pageSize: state.data.pageSize }, payload: action.data };
    }
    case `${namespace}/QUERY_PAGE_REQUEST_RESET_PAYLOAD`: {
      return { ...state, data: { ...state.data, page: 0, pageSize: state.data.pageSize }, payload: { ...initialState.payload } };
    }
    case `${namespace}/QUERY_PAGE_REQUEST_RESET`: {
      return initialState;
    }
    default:
      return state;
  }
};
